export function autoResizeSelectDirective($document, $window) {
    'ngInject';
    return {
        restrict: 'A',
        scope: {
            model: '=ngModel',
            config: '=autoResizeSelect',
        },
        link: function (scope, elem, attr) {
            // hard coded atm, should pass these in
            const EXTRA_WIDTH = attr.type === 'number' ? 14 : 5; //px
            const VALUE_KEY = 'value';
            const DISPLAY_KEY = 'display';

            const testSpanEl = document.createElement('span');

            let lastContentStr;

            $document.find('body').append(testSpanEl);

            // copy styles from the original element, will NOT be updated if the original element's styles change
            const styles = $window.getComputedStyle(elem[0]);

            Object.assign(testSpanEl.style, {
                ['font-family']: styles.getPropertyValue('font-family'),
                ['font-size']: styles.getPropertyValue('font-size'),
                ['font-weight']: styles.getPropertyValue('font-weight'),
                ['padding']: styles.getPropertyValue('padding'),
                ['padding-left']: styles.getPropertyValue('padding-left'),
                ['padding-right']: styles.getPropertyValue('padding-right'),
                ['padding-bottom']: styles.getPropertyValue('padding-bottom'),
                position: 'absolute',
                left: 0,
                visibility: 'hidden',
                width: 'auto',
                display: '',
            });

            function resize(content) {
                const str = content ? `${content}` : '';
                if (str !== lastContentStr) {
                    testSpanEl.textContent = str;
                    elem[0].style.width = `${testSpanEl.offsetWidth + EXTRA_WIDTH}px`;
                    lastContentStr = str;
                }
            }

            function dropdownUpdate() {
                // at the moment, the config binding is used to pass through a list of dropdown options
                // each option has a VALUE_KEY (corresponding to a possible model value) and a DISPLAY_KEY
                const options = scope.config;
                const model = scope.model;

                // use the display value of a matched option as the content string
                const option = options.find((o) => o[VALUE_KEY] === model);
                resize(option ? option[DISPLAY_KEY] : lastContentStr);
            }

            function inputUpdate(event) {
                resize(event.srcElement.value);
            }

            function removeTestSpanEl() {
                if (testSpanEl && testSpanEl.parentNode) {
                    testSpanEl.parentNode.removeChild(testSpanEl);
                }
            }

            if (scope.config) {
                scope.$watch('model', dropdownUpdate);
                scope.$watch('config', dropdownUpdate);
            } else {
                // use the model value for our initial size as the input will not have filled yet
                resize(scope.model);
                elem[0].addEventListener('input', inputUpdate);
            }

            scope.$on('$destroy', removeTestSpanEl);
        },
    };
}
